// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/on-demand/global-global-social-module-styles") return "spa-assets/on-demand/global-global-social-module-styles-e9939658e8ebc4969ffa.js";
	if (chunkId === "spa-assets/js/vendors/vue-router") return "spa-assets/js/vendors/vue-router-844e9e6fee0a9a8291f8.js";
	if (chunkId === "spa-assets/js/jcrs/global-en-social-social.json") return "spa-assets/js/jcrs/global-en-social-social-jcr-7cacd673479082e1c7f2.js";
	if (chunkId === "spa-assets/js/jcrs/global-es-social-social.json") return "spa-assets/js/jcrs/global-es-social-social-jcr-1a6113b2a8417e6b85b7.js";
	// return url for filenames based on template
	return undefined;
};